var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeeksoftheworld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.2 468.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-10, .cls-5, .cls-7, .cls-8, .cls-9 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: 1px;\n      }\n\n      .cls-2, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        stroke-width: 1px;\n      }\n\n      .cls-3, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-10, .cls-5, .cls-11, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-11 {\n        stroke: #000;\n      }\n\n      .cls-10, .cls-11, .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-10, .cls-9 {\n        stroke-width: 5px;\n      }\n\n      .cls-6, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-11 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-7 {\n        stroke-width: 5px;\n      }\n\n      .cls-8 {\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Black_Circle_01",
    "data-name": "Black Circle 01",
    className: "cls-1",
    d: "M193.2,63.8c100,0,157.3,89.5,121.2,185-29.3,77.4-107.3,127.7-180.3,127.7S2,325,2,248.8,92.9,63.8,193.2,63.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_Circle_01",
    "data-name": "White Circle 01",
    className: "cls-12",
    d: "M177.5,119.7c71,0,112.8,61.3,90.6,128.6-19.3,58.8-78.3,98.1-133.6,98.1s-99.4-40.1-96.4-98.1c3.4-67.2,68.2-128.6,139.4-128.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Black_Circle_02",
    "data-name": "Black Circle 02",
    className: "cls-6",
    d: "M173.3,139.2c61,0,97.2,52,79.3,109.7-16,51.6-67.7,86.6-116.4,86.6s-87.1-35.6-83.6-86.6c3.9-57.4,59.5-109.7,120.8-109.7h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.6,308.2l-29.7,5.6c-5.5,1-9.8-2.7-9.7-8.4l2.2-83.6c.2-6.9,5.3-14.3,11.6-16.5l33.7-11.6c7-2.4,12.2,1.9,11.6,9.5l-7.7,91.7c-.5,6.2-6,12.1-12.1,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.8,389.3h0c-.2.4-.3.8-.3,1.2v1.3c0,.3,0,.5.1.8l.3,1c.2.8.8,1.4,1.5,1.8s1.6.8,1.8.8c.4,0,7.8.2,8.1,0,.4-.2,21.2-3.4,24.6-3.9.3,0,.6-.1.9-.3l1.9-1c.4-.2.7-.4.9-.7l.8-.9c.2-.3.4-.6.6-1l.5-1.6c.1-.3.1-.6.1-1v-3.6c0,0,0-1.4,0-1.4,0-1.7-1.4-3-3.1-2.9l-13.3.8c-.2,0-.4,0-.6.1l-3.8,1.1c0,0-.2,0-.3,0l-19.1,7.6c-.7.3-1.2.8-1.6,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.6,382.4l-13.5-1.5c-1.8-.2-3.3-1.4-3.2-2.7l4.3-64.8c.1-2.1,2.2-3.6,4.6-3.4l17.4,1.9c2.4.3,4.1,2.2,3.8,4.2l-9.6,64.2c-.2,1.3-1.9,2.2-3.7,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.8,301.7l23.7,128.8c.1.7-.4,1.5-1.1,1.6,0,0-43.8,5.9-44.9,5.1s-5.8-132.6-5.8-132.6l28-3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.3,436.1l1.8-3.4c.6-1.5,2.2-2.9,5.1-3.1l11.8-1.1c17.4-.5,23.9,1.4,24.3,1.8l22.4,24.7c.5.6.9,1.4.9,2.2l.2,6.5c0,.7-.3,1.4-.9,1.8l-.2.2c-.4.3-.9.4-1.4.4l-51.4-1.5c-.7,0-1.4-.3-1.9-.7l-4.9-4c-.5-.4-.9-1-1-1.6l-5-20.7c-.1-.5,0-1.1.3-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.3,468.6h-.1l-51.4-1.5c-1.2,0-2.4-.5-3.4-1.3l-4.9-4c-.9-.7-1.6-1.8-1.9-2.9l-5-20.7c-.3-1.2,0-2.4.6-3.4l1.7-3.2c1.1-2.5,3.8-4.2,7.2-4.5l11.9-1.1c13.9-.4,24.4.7,26.2,2.7l22.4,24.7c1,1,1.5,2.4,1.5,3.8l.2,6.5c0,1.5-.7,3-1.9,3.8l-.2.2c-.8.6-1.8.9-2.8.9h0ZM148.5,437.3l5,20.4c0,.1,0,.2.1.2l4.9,4c.1,0,.2.1.4.1l51.3,1.5-.2-6.2c0-.2,0-.4-.2-.6l-22-24.4c-1.2-.4-7.1-1.8-22.6-1.4l-11.7,1.1c-1.5.1-2.7.7-3,1.6v.2c0,0-1.9,3.5-1.9,3.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M186.7,6.9l-34.4,2.6c-3.1.2-5.4,3.1-5.2,6.4l1.9,26.3c.2,3.3,3,5.9,6.1,5.9l34.8-.6c3.5,0,6.2-3,5.9-6.5l-2.2-28.2c-.3-3.5-3.4-6.1-6.8-5.9h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "177.4 197.8 152.1 190.7 152 45 191.5 47.3 177.4 197.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M166.7,200.4l-30.9,7.9c-3.1.8-6.2-1.2-7-4.4l-10-38.9c-.8-3.2.9-6.6,3.9-7.6l30.3-10.3c3.3-1.1,6.7.7,7.6,4.1l10.6,41.3c.9,3.4-1.2,6.9-4.5,7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lens1",
    className: "cls-10",
    d: "M133.6,191.9l-5.7,2.2c-3.1,1.2-6.5-.3-7.4-3.4l-3.3-10.6c-.6-2,.5-4.4,2.6-5.1l7.6-2.9c3.1-1.2,6.5.3,7.4,3.4l2.8,8.8c1,3.1-.8,6.5-4,7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lens1-2",
    className: "cls-10",
    d: "M145.3,188.7l-5.7,2.2c-3.1,1.2-6.6-.5-7.6-3.9l-3.7-11.6c-.7-2.2.4-4.7,2.5-5.5l7.6-2.9c3.1-1.2,6.6.5,7.6,3.9l3.1,9.6c1.1,3.3-.6,7-3.8,8.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pinky",
    className: "cls-9",
    d: "M190.3,3.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V10.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    className: "cls-9",
    d: "M165.3,3.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V10.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ring",
    className: "cls-9",
    d: "M178.3,2.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V9.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pointer",
    className: "cls-9",
    d: "M152.3,7.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V14.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 152.8,
    y: 21.9,
    width: 16.6,
    height: 37.7,
    rx: 6.7,
    ry: 6.7,
    transform: "translate(62.6 174.6) rotate(-67.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thumb1",
    className: "cls-8",
    d: "M136.5,35.9h0c-.7-3.6,1.7-7.1,5.3-7.8l28.4-5.5c3.6-.7,7.1,1.7,7.8,5.3h0c.7,3.6-1.7,7.1-5.3,7.8l-28.4,5.5c-3.6.7-7.1-1.7-7.8-5.3Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Geek"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Torso"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.6,308.2l-29.7,5.6c-5.5,1-9.8-2.7-9.7-8.4l2.2-83.6c.2-6.9,5.3-14.3,11.6-16.5l33.7-11.6c7-2.4,12.2,1.9,11.6,9.5l-7.7,91.7c-.5,6.2-6,12.1-12.1,13.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rear_Foot",
    "data-name": "Rear Foot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.8,389.3h0c-.2.4-.3.8-.3,1.2v1.3c0,.3,0,.5.1.8l.3,1c.2.8.8,1.4,1.5,1.8s1.6.8,1.8.8c.4,0,7.8.2,8.1,0,.4-.2,21.2-3.4,24.6-3.9.3,0,.6-.1.9-.3l1.9-1c.4-.2.7-.4.9-.7l.8-.9c.2-.3.4-.6.6-1l.5-1.6c.1-.3.1-.6.1-1v-3.6c0,0,0-1.4,0-1.4,0-1.7-1.4-3-3.1-2.9l-13.3.8c-.2,0-.4,0-.6.1l-3.8,1.1c0,0-.2,0-.3,0l-19.1,7.6c-.7.3-1.2.8-1.6,1.5h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rear_Leg",
    "data-name": "Rear Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.6,382.4l-13.5-1.5c-1.8-.2-3.3-1.4-3.2-2.7l4.3-64.8c.1-2.1,2.2-3.6,4.6-3.4l17.4,1.9c2.4.3,4.1,2.2,3.8,4.2l-9.6,64.2c-.2,1.3-1.9,2.2-3.7,2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Front_Leg",
    "data-name": "Front Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.8,301.7l23.7,128.8c.1.7-.4,1.5-1.1,1.6,0,0-43.8,5.9-44.9,5.1s-5.8-132.6-5.8-132.6l28-3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Front_Foot",
    "data-name": "Front Foot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.3,436.1l1.8-3.4c.6-1.5,2.2-2.9,5.1-3.1l11.8-1.1c17.4-.5,23.9,1.4,24.3,1.8l22.4,24.7c.5.6.9,1.4.9,2.2l.2,6.5c0,.7-.3,1.4-.9,1.8l-.2.2c-.4.3-.9.4-1.4.4l-51.4-1.5c-.7,0-1.4-.3-1.9-.7l-4.9-4c-.5-.4-.9-1-1-1.6l-5-20.7c-.1-.5,0-1.1.3-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.3,466.6h0l-51.4-1.5c-.8,0-1.6-.3-2.2-.8l-4.9-4c-.6-.5-1-1.1-1.2-1.9l-5-20.7c-.2-.7,0-1.4.4-1.9l1.8-3.4c.4-.9,1.7-3.1,5.5-3.4l11.8-1.1c17.1-.5,24.1,1.3,24.7,2l22.4,24.7c.6.7,1,1.6,1,2.5l.2,6.5c0,.9-.4,1.7-1,2.2l-.2.2c-.5.3-1,.5-1.6.5h0ZM170.6,428.9c-1.7,0-3.6,0-5.6,0l-11.7,1.1c-3.3.3-4.4,2.1-4.7,2.8l-1.9,3.5c-.2.3-.3.7-.2,1.1l5,20.7c.1.5.4,1,.8,1.3l4.9,4c.5.4,1,.6,1.6.6l51.4,1.5c.4,0,.8-.1,1.1-.3l.2-.2c.4-.3.7-.8.6-1.4l-.2-6.5c0-.7-.3-1.4-.8-1.9l-22.4-24.7c-.4-.3-5.4-1.8-18.3-1.8h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.7,6.9l-34.4,2.6c-3.1.2-5.4,3.1-5.2,6.4l1.9,26.3c.2,3.3,3,5.9,6.1,5.9l34.8-.6c3.5,0,6.2-3,5.9-6.5l-2.2-28.2c-.3-3.5-3.4-6.1-6.8-5.9h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "177.4 197.8 152.1 190.7 152 45 191.5 47.3 177.4 197.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.7,200.4l-30.9,7.9c-3.1.8-6.2-1.2-7-4.4l-10-38.9c-.8-3.2.9-6.6,3.9-7.6l30.3-10.3c3.3-1.1,6.7.7,7.6,4.1l10.6,41.3c.9,3.4-1.2,6.9-4.5,7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lens1-3",
    className: "cls-11",
    d: "M133.6,191.9l-5.7,2.2c-3.1,1.2-6.5-.3-7.4-3.4l-3.3-10.6c-.6-2,.5-4.4,2.6-5.1l7.6-2.9c3.1-1.2,6.5.3,7.4,3.4l2.8,8.8c1,3.1-.8,6.5-4,7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Lens1-4",
    className: "cls-11",
    d: "M145.3,188.7l-5.7,2.2c-3.1,1.2-6.6-.5-7.6-3.9l-3.7-11.6c-.7-2.2.4-4.7,2.5-5.5l7.6-2.9c3.1-1.2,6.6.5,7.6,3.9l3.1,9.6c1.1,3.3-.6,7-3.8,8.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pinky-2",
    className: "cls-5",
    d: "M190.3,3.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V10.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle-2",
    className: "cls-5",
    d: "M165.3,3.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V10.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ring-2",
    className: "cls-5",
    d: "M178.3,2.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V9.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pointer-2",
    className: "cls-5",
    d: "M152.3,7.5h0c3.7,0,6.7,3,6.7,6.7v19.3c0,3.7-3,6.7-6.7,6.7h0c-3.7,0-6.7-3-6.7-6.7V14.2c0-3.7,3-6.7,6.7-6.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.8,
    y: 21.9,
    width: 16.6,
    height: 37.7,
    rx: 6.7,
    ry: 6.7,
    transform: "translate(62.6 174.6) rotate(-67.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Thumb1-2",
    className: "cls-3",
    d: "M136.5,35.9h0c-.7-3.6,1.7-7.1,5.3-7.8l28.4-5.5c3.6-.7,7.1,1.7,7.8,5.3h0c.7,3.6-1.7,7.1-5.3,7.8l-28.4,5.5c-3.6.7-7.1-1.7-7.8-5.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeeksoftheworld);
export default __webpack_public_path__ + "static/media/geeksoftheworld.abc6218b63d4854fcaf8ded917eafbc6.svg";
export { ForwardRef as ReactComponent };